const theme = {}

export const colors = {}

export default theme
